import { render } from "./Products.vue?vue&type=template&id=e19b8bd0"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
script.render = render

export default script